/**
 * done
 */
import React from 'react';
import { wrapReactionHook, useDict } from "../../hooks";
import { isEmpty } from '@formily/shared';
export var DictCascaderText = wrapReactionHook(function (props) {
  var dictType = props.dictType,
    value = props.value,
    _props$level = props.level,
    level = _props$level === void 0 ? 1 : _props$level,
    _props$childrenLoadLe = props.childrenLoadLevel,
    childrenLoadLevel = _props$childrenLoadLe === void 0 ? 5 : _props$childrenLoadLe,
    _props$delimiter = props.delimiter,
    delimiter = _props$delimiter === void 0 ? '/' : _props$delimiter,
    addonAfter = props.addonAfter,
    placeholder = props.placeholder,
    url = props.url,
    _props$params = props.params,
    params = _props$params === void 0 ? {} : _props$params,
    autoRemoveDict = props.autoRemoveDict,
    enums = props.enums,
    getText = props.getText;
  var options = useDict(dictType, {
    level: level,
    childrenLoadLevel: childrenLoadLevel,
    autoRemoveDict: autoRemoveDict,
    url: url,
    params: params,
    enums: enums
  });
  if (isEmpty(value)) {
    return '-';
  }
  if (Array.isArray(value) && options) {
    var currentOptions = options;
    var labels = value.reduce(function (list, current) {
      if (currentOptions) {
        var item = currentOptions.find(function (i) {
          return i.value === current;
        });
        if (item) {
          list.push(item.label);
          list.push(delimiter);
          currentOptions = item.children;
        }
      }
      return list;
    }, []);
    labels.pop();
    var _text = labels.join('');
    getText && getText(_text);
    return /*#__PURE__*/React.createElement(React.Fragment, null, labels.length ? _text : placeholder, addonAfter);
  }
  return '-';
});